module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.label) ? _c('label', [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('input', _vm._b({
    staticClass: "form-control border-input",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  }, 'input', _vm.$props, false))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8136e24a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Inputs/formGroupInput.vue
// module id = 372
// module chunks = 1